import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IApplicationState } from "../stores/AppStore";
import {slicePlayList } from "../stores/AppReducer";
import { IAppState } from "../interfaces/App";

function MediaPlayer() {
    const dispatch = useDispatch();
    const app: IAppState = useSelector((appState: IApplicationState) => appState.app);
    const [trackProgress, setTrackProgress] = useState(0);
    const [trackIndex, setTrackIndex] = useState(-1);
    const [isPlaying, setIsPlaying] = useState(false);
    const audioRef = useRef(new Audio());
    const timerRef = useRef(null);

    const canPlay = () => {
      return app.playList?.length > 0;
    };

    const play = () => {
      if (audioRef?.current && !isPlaying) {
        setIsPlaying(true);
        audioRef?.current?.play();
        startTimer();
      }
    };

    const stop = () => {
      if (isPlaying) {
        setIsPlaying(false);
        audioRef?.current?.pause();
      }
    };

    const resetTimer = () => {
      clearInterval(timerRef.current);
    };

    const startTimer = () => {
      timerRef.current = setInterval(() => {
        if (audioRef?.current?.ended) {
          playNext();
        } else {
          setTrackProgress(audioRef?.current?.currentTime);
        }
      }, 1000);
    };

    const playNext = () => {
      dispatch(slicePlayList(trackIndex + 1));
    };

    const changeTrackIndex = (dir: number) => {
      const newTrack = trackIndex + dir;
      stop();
      resetTimer();
      if (newTrack > -1 && newTrack < app.playList.length) {
        audioRef.current = new Audio(app.playList[newTrack].audioSrc);
        setTrackIndex(newTrack);
      }
    };

    // const changeProgress = (val: number) => {
    //   if (audioRef?.current) {
    //     audioRef.current.currentTime = val;
    //   }
    // };

    useEffect(() => {
      const auto = isPlaying;
      if (isPlaying) {
        stop();
        resetTimer();
      }
      setTrackIndex(canPlay() ? 0 : -1);
      audioRef.current = canPlay() ? new Audio(app.playList[0].audioSrc) : null;
      if (auto) {
        setIsPlaying(true);
        audioRef?.current?.play();
        startTimer();
      }
    }, [app.playList]);

    const duration = audioRef?.current?.duration ? audioRef?.current?.duration : 0;

    return app.playList.length 
    ? (
      <div className="mediaPlayer">
          <div className="trackPad">
            <span>{ (trackIndex > -1 && canPlay()) ? app.playList[trackIndex].title : ""} : {trackIndex + 1}/{app.playList?.length}</span>
            <span>{renderTime(duration - trackProgress)}</span>
            <span>
              <button onClick={() => changeTrackIndex(-1)} className="trackButton"> &lt;&lt;</button>
              <button onClick={isPlaying ? () => stop() : () => play()}  className="trackButton"> {isPlaying ? "stop" : "play"}</button>
              <button onClick={() => changeTrackIndex(+1)} className="trackButton"> &gt;&gt;</button>
            </span>
            {/* <input
              type="range"
              value={trackProgress}
              step="1"
              min="0"
              max={duration}
              className="progress"
              onChange={(e: any) => changeProgress(parseFloat(e.target.value))}
            /> */}
          </div>
        <div className="clear"/>
      </div>
    ) : (null);
}

const renderTime = (tm: number) => {
    const t = tm > 0 ? tm / 60 : 0;
    const m = Math.trunc(t);
    const s = Math.round((t - m) * 60);
    return m + (s < 10 ? ":0" : ":") + s; 
};

export default MediaPlayer;
